export const NAME = 'credentials';
export const ADD_CREDENTIAL_FORM = 'addCredentialForm';
export const UPDATE_CREDENTIAL_FORM = 'updateCredentialForm';
export const CREDENTIAL_IMAGE_FORM = 'credentialImageForm';
// export const REASSIGN_CODE_FORM = 'reassignCodeForm';